import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, Col, Container, ProgressBar, Row } from "react-bootstrap";
import ErrorMessage from "../../components/common/ErrorMessage";
import InputField from "../../components/common/InputField";
import history from "../../history";
import types from "../../types/types";

import { Entities } from "../Entities";
import { ButtonBack } from "../../components/common/ButtonBack";
import { confirmAlert } from "react-confirm-alert";
import { useisLoading } from "../../hook/useisLoading";
import Loading from "../../components/common/Loading";
import { useSelector } from "react-redux";
import { ApplicationsAPI, Infra, InfraAPI, UsersAPI } from "../../components/apis";
import snxServiceStates from "./helper/snxServiceStates";
import { ButtonGeneric } from "../../components/common/ButtonGeneric";
import ButtonHelp from '../../components/common/ButtonHelp';
import { message } from '../../components/common/Notification';

export const Application = (props, context) => {

    console.log("Enter into Application.js...")
    
    const { user, token } = useSelector(state => state.user);

    const [apiApplications, setApiApplications] = useState(null);
    const [apiInfra, setApiInfra] = useState(null);
        
    // Main Spinner
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);
    // Spinner for Postman file generation
    const { isLoading: isLoadingPostman, showSpinner: showSpinnerPostman, hideSpinner: hideSpinnerPostman } = useisLoading(false);
    // Spinner for Token generation
    const { isLoading: isMetadataReloading, showSpinner: showMetadataReloading, hideSpinner: hideMetadataReloading } = useisLoading(false);
    
    const [application, setApplication] = useState(null)

    // Get account list from Redux
    const { accounts } = useSelector(state => state.accounts);
    // Used for load account selected
    const [account, setAccount] = useState(null)
    // const businessdb = businessdb && businessdb.length > 0 ? businessdb[0] : null;
    const [bussinesDB, setBussinesDB] = useState(null);
    
    // stack-for-check, stack-unknown, stack-creating, stack-starting, stack-created, stack-stopped, stack-destroying, re-unkwnon, re-starting, re-started, re-metadata-reloading, re-restarting
    const [infraWorkOnAction, setInfraWorkOnAction] = useState(snxServiceStates.stack_for_check);
    const [lastSXREEvent, setLastSXREEvent] = useState(null);
    const [sxreStack, setSxreStack] = useState(null);

    // const [backendError, setBackendError] = useState(null);
       
    const { register, handleSubmit, getValues, setValue } = useForm({
        defaultValues: {
            // variable: null,
            username: null,
            password: null,
        }
    });

    // const selectedAccount = getAccountById(props.idAccount);

    // Get selected Account from Redux
    useEffect(() => {
        if(accounts || accounts.length > 0){
            accounts.find(
                (accountSelected) => {
                    if (accountSelected.id === Number(props.idAccount)){
                        setAccount(accountSelected);
                    }
                }
            );
        }
    }, [accounts])

    // Load user's Account
    useEffect(() => {
        
        if (token) {
            setApiApplications(new ApplicationsAPI(token, props.idAccount));
            setApiInfra( new InfraAPI(token));
            
            hideSpinner();
        }

    }, [token])


    // Load selected Application
    useEffect(() => {
        
        if (apiApplications){
            
            apiApplications.get(props.id).then((response) => {     
                setValue("apikey", response.apikey);
                setValue("audience", response.audience);
                setApplication(response);
            })
            .catch((err) => {
                console.log("Catch getAplication():"+ err);
                setValue(types.ERROR, "ERROR CODE: Get Application failed.");
                // setBackendError("ERROR CODE: Get Application failed.");
            });
        }

    }, [apiApplications]);

    // Load Business Database related
    useEffect(() => {
        
        if (application){

            apiApplications.getDBs(props.id).then((dbs) => {
                setValue("databaseName", dbs[0].name);
                setValue("databaseHost", dbs[0].database_host +":" + dbs[0].database_port);
                setBussinesDB(dbs);
            })
            .catch((err) => {
                console.log("Error loading Business Database related:"+ err); 
                setValue(types.ERROR, "ERROR CODE: Get Bussines DB failed.");               
                // setBackendError("ERROR CODE: Get Bussines DB failed.");
            });
        }

    }, [application]);
    

    // Check application status
    useEffect(() => {
    
        if (bussinesDB){
            _getStack();
        }
    
    }, [bussinesDB])



    // Check application events
    useEffect(() => {
    
        if (sxreStack){
            _getStackStatus();
            console.log(infraWorkOnAction);         
        } 

    }, [sxreStack])
    

    useEffect(() => {
        
        if (infraWorkOnAction !== snxServiceStates.re_started && 
            infraWorkOnAction !== snxServiceStates.stack_for_check &&
            infraWorkOnAction !== snxServiceStates.stack_destroying){

                setTimeout(() => {
                    _getStackStatus();            
                }, 2500);

        }
        hideSpinner();

    }, [lastSXREEvent])
    


    const _getStackStatus = () => {     
        
        apiInfra.getPlatformLastEvent(props.id, apiApplications.token)
            .then((services) => {
          
            const sinexiarService = services.stacks[0];
            // const {event_type, category, unit, value, message, created_at} = sinexiarService.lastevent;
        
            setInfraWorkOnAction(sinexiarService.status_desc);
            setLastSXREEvent(sinexiarService);

        })
        .catch((err) => {
            
            // While the stack is being destroyed, the "stack-for-check" state is forced since at some point the event service
            // will return an error since the stack will effectively no longer exist.
            if (infraWorkOnAction === snxServiceStates.stack_destroying) {
                    setInfraWorkOnAction("stack-for-check");
            } else {
                setInfraWorkOnAction(snxServiceStates.stack_unknown);
            }
            console.log(`Error retrieving stack status for aplicatión Stack with id=${props.id}.`, err)

        });
    }

    
    // Method that tries to obtain the stack from an "application id", to obtain it and evaluate its state from reading the log events registered 
    // and associated with said stack through the getPlatformEvents method.
    // Set the "state" instance variables by updating the "infraWorkOnAction" attribute with the actual state obtained from the actual registered services. 
    // The "infraWorkOnAction" attribute is used to evaluate at different places on the page which objects to show/hide.
    const _getStack = () => {
        
        apiInfra.getStackFromApp(props.id)
            .then((stack) => {            
                setSxreStack(stack);
                setValue("stackName", stack.name);
                setValue("stackId", stack.stack_id);
                setValue("idSwarm", stack.swarm_id);
            })
            .catch((err) => {
                console.log(`Catch _getStack: Error retrieving stack for aplicatión Stack with id=${props.id}`, err);
                
                // setValue(types.ERROR, "There is no application started.");    
                
            });
    }

    // Renderiza la barra de progreso que representa el start-up del motor rest de una Aplicación Cliente.
    const renderProgressBar = () => {
        
        if(lastSXREEvent != null){    
            const { event_type, created_at, category, message, value } = lastSXREEvent.lastevent;
            return (
                <>       
                    <ProgressBar animated now={value} label={value + "%"}/>
                    <p className="eventText">{`Sinexiar event activity: ${event_type} Category: ${category}`}</p>
                    <p className="eventText"> 
                        {`${created_at} - ${event_type} - ${message}`}
                    </p>
                </>
            ) 
        } else {
            return <><p className="eventText">{`Sinexiar RestEngine RESTful API has not been started.`}</p></>
        } 
    }

    // Function to handle login service and copy "token" received into the user clipboard.
    const _getApplicationToken = (username, password, onClose) => {
        
        const apiUser = new UsersAPI(token);
        apiUser.loginForToken(application.appInstance_name, username, password).then( (applicationToken) =>{
            navigator.clipboard.writeText(applicationToken)
            onClose();
            message(context.t("Token Generated"), context.t("The token was copied to your clipboard"));            
        })
        .catch((err) => {            
            document.getElementById("errorId").classList.remove('d-none');
        })
        .finally(()=>{
            setValue("username", null);
            setValue("password", null);
        });
    }

    // Show Popup for login and retrieve an application token.
    const _loginPopup = () => {
                
        confirmAlert({
            customUI: ({ onClose }) => {
                return (                    
                    <div className='custom-ui'>
                        <h1>{context.t('Token Generator')}</h1>

                        <InputField label= { "User" }
                            name="username"
                            useFormRegister= { register("username") }
                        />
                        <InputField label= { "Password" }
                            name="password"
                            type="password"
                            useFormRegister= { register("password") }
                        />
                        <p id="errorId" className='error-message m-0 text-center d-none'>
                            {context.t("Invalid username or password")}
                        </p>
                        <br/>
                        <Button variant="outline-primary mb-2 mr-1" id="loginBtn" onClick={() => {
                            _getApplicationToken(getValues().username, getValues().password, onClose);
                        }} >{context.t('Login')}</Button>
                        <Button variant="outline-secondary mb-2 mr-1" onClick={() => {onClose() }} >{context.t('Cancel')}</Button>
                        
                    </div>
              );
            }
          });
        
    }

    const handleCopyForPostman = (postmanJson) => {
        
        navigator.clipboard.writeText(postmanJson)
        .then(  ok => {
                    window.close();
                },
                error => {
                    alert("Error on copying to clipboard.")
                }
        )
    }

    // Funciton to export URI definitions to Postman Application
    const _getPostmanExportFile = () => {

        showSpinnerPostman();
        
            const infraApi = new InfraAPI();
            infraApi.getSwagger(application.appInstance_name)
            .then(data => {
                console.log("json", data);
                const postmanJson = JSON.stringify(data);

                confirmAlert({       
                    title: context.t('Postman Export File Generator'),
                    // message: 'Postman Application',
                    childrenElement: () => (
                            <Container>
                                <br />
                                <Row>
                                <Card>
                                    <Card.Body>
                                    <Card.Text>
                                        {` ${postmanJson && postmanJson.substring(0, postmanJson.length < 1500 ? postmanJson.length : 1500)} ...`}
                                    </Card.Text>
                                    <Button variant="btn btn-outline-primary mb-2 mr-1" onClick={ () => handleCopyForPostman(postmanJson)} >{context.t("Copy to Clipboard")}</Button>
                                    &nbsp;
                                    <a 
                                        target={`${application.appInstance_name}-postman-download`}
                                        download={ "postman-collection.json" }
                                        href={ `data:text/plain;charset=utf-8,${encodeURIComponent(postmanJson)}` }
                                    >
                                        <Button variant="btn btn-outline-primary mb-2 mr-1" onClick={ handleCopyForPostman }>{context.t("Download File")}</Button>
                                    </a>
                                    </Card.Body>
                                </Card>
                                </Row>
                            </Container>
                        )
                    ,
                    overlayClassName: "react-confirm-alert-body-overlay",
                    buttons: [
                        {
                            label: context.t('Close'),
                            // onClick: () => { handleCopy }
                        }
                    ]
                });

                hideSpinnerPostman();

            })
            .catch(err => {
                // setAlertVisible(true);
                console.log(err);
                // setBackendError(context.t("Something went wrong!"));
                setValue("backenError", context.t("Something went wrong!"));
                hideSpinnerPostman();
            })


    }


    const handleStartStack = (event) => {
        event.preventDefault();
        event.stopPropagation();

        // TODO: Add spiner
        
        const stack = new Infra({
            stack_name: application.appInstance_name,
            client_name: account.name,
            account_id: account.id,
            app_id: application.id,
            db_id: bussinesDB[0].id,
            prefix_catalog_scheme: false,
            metadatadb_type: "pg95",
            metadatadb_host: "",
            metadatadb_port: "",
            metadatadb_name: "",
            businessdb_type: "",
            businessdb_host: "",
            businessdb_port: "",
            businessdb_name: "",
            user_timezone: "America/Argentina/Buenos_Aires",
            redatetime_format: "yyyy-MM-dd'T'HH:mm:ssXXXXX",
            business_db_timezone: "GMT",
            business_db_datetime_format: "yyyy-MM-dd HH:mm:ss",
        });
            
        apiInfra
            .create(stack)
            .then(() => {
                // Se comezó a iniciar los servicios de creación del stack
                // Se setea el estado de la infra en el valor "stack-starting" que determina los componentes a renderizar a travéz del método renderMainInfraLoading().
                setInfraWorkOnAction(snxServiceStates.stack_starting);
                setSxreStack(stack);
                setValue("stackName", stack.name);
                setValue("idSwarm", stack.swarm_id);
            })
            .catch((err) => {
                console.log("Catch handleStartStack: " + err);
                setInfraWorkOnAction(snxServiceStates.stack_for_check);
                
        });
    };

    const handleMetadataReload = (event) => {
        event.preventDefault();
        event.stopPropagation();

        showMetadataReloading();
        const stackIdValue = getValues().stackId;

        if (stackIdValue) {

            const stackToReload = new Infra({
                account_name: account.name,
                app_id: application.id,
                stack_id: stackIdValue,
            });

            apiInfra.reloadMetadata(stackToReload)
                .then(() => {
                    console.log("Metadata reloaded")
                })
            .catch((err) => {
                console.log("Catch handleMetadataReload ");
                console.log(err)
            }).finally(() => {
                // After reload database metadata, we set "stack for check" and then execute getStack() function in order to check the actual stack state
                setInfraWorkOnAction(snxServiceStates.stack_for_check);                
                _getStack();
                hideMetadataReloading();
            });

        } else {
            setValue(types.ERROR, context.t("There was a problem on our end. Please try again later."));
            hideMetadataReloading();
        }
        
    }

    const handleRestartStack = (event) => {
        event.preventDefault();
        event.stopPropagation();
    
        setInfraWorkOnAction(snxServiceStates.re_restarting);
        
        apiInfra
            .restart(sxreStack)
                .then(() => {
                    // TODO revisar que estado forzar en este bloque. infraWorkOnAction: "re-started":
                    // setInfraWorkOnAction(snxServiceStates.re_restarting);
                })
          .catch((err) => {
              console.log("Catch handlerResrtStack");
              setInfraWorkOnAction(snxServiceStates.stack_for_check);
          });
    };

    const handleStopProcess = (event) => {
        // TODO Stop RESTengine.
    }
    
    const handleDestroyStack = (event) => {
        event.preventDefault();
        event.stopPropagation();
    
        setInfraWorkOnAction(snxServiceStates.stack_destroying);
        let newStack = new InfraAPI(token);
        apiInfra.destroy(sxreStack)
            .then(() => {  
                setSxreStack(newStack);
                setInfraWorkOnAction(snxServiceStates.stack_for_check);
            }).catch((err) => {
                console.log("Catch handleDestroyStack: " + err);
                setInfraWorkOnAction("stack-for-check");
                // setBackendError(err);
                setValue(types.ERROR, err);
          });
    };

    const [initGuide, setInitGuide] = useState(false);
    const showHelp = (event) => {        
        event.preventDefault();
        event.stopPropagation();
        setInitGuide(true);

    }

    const renderMainInfraLoading = (infraWorkOnAction, progress, message) => {
        
        switch (infraWorkOnAction) {
        
            case snxServiceStates.stack_for_check:
                return <>{"Just start your RestEngine and get your RESTful API."}</>
            case snxServiceStates.stack_unknown:
                return <>{" " + context.t("There is no RestEngine RESTful Application detected")}</>
            case snxServiceStates.re_started:
                return  <Entities token={token} application={application} account={account} infraWorkOnAction={infraWorkOnAction} />
            case snxServiceStates.re_starting:     
                return renderProgressBar();
            case snxServiceStates.stack_creating: 
                return renderProgressBar();
            case snxServiceStates.stack_created: 
                return renderProgressBar();
            // case 're-stopped':
            //     return <><i className="fas fa-cog fa-spin"></i>{" " + context.t("Stopping the stack...")}</>
            case snxServiceStates.re_metadata_reloading:
                return <><i className="fas fa-cog fa-spin"></i>{" " + context.t("Restarting the stack...")}</>
            case snxServiceStates.stack_destroying:
                return <><i className="fas fa-cog fa-spin"></i>{" " + context.t("Destroying the stack...")}</>
            case snxServiceStates.stack_destroying:
                return <>{" " + context.t("There is no RestEngine RESTful Application detected")}</>
            default:
                return (
                    <>
                    <i className="fas fa-cog fa-spin"></i><p className="eventText">{"Sinexiar RestEngine is working to retrive IaaS"}</p>
                    </>
                )
        }
    }

    if (isLoading || !account || !application || !bussinesDB) {
        return <Loading/>
    } else {
        return (
            <>
                {/* If "backendError" has value, it shows to the user */}
                <ErrorMessage message={getValues().backendError} useFormSetValue={setValue}/>
                
                <Container fluid className="main-content-container px-4">
                    <br />
                    <br />
                    <Row>
                    <Col lg="4" >                        
                        <Card className="snx-card mb-4 pt-0">
                            <Card.Header className="border-bottom text-center">
                                <div className="mb-3 mx-auto">
                                    <i className="material-icons blue-text" style={{ fontSize: "48px" }} >apps</i>
                                </div>
                                <h5 className="mb-0"> {application.name} </h5>
                                <span className="text-muted d-block mb-2">
                                    {context.t("Account")} : {account.name}
                                </span>
                            </Card.Header>
                            <Card.Body>
                                <Container>
                                    <Row id="UG_stackActionButtons">
                                        <Col className="d-flex justify-content-around">
                                        {user.roles[0].id === types.USER_ROOT_ID ||
                                        user.roles[0].id === types.USER_ADMIN_ID ||
                                        user.roles[0].id === types.USER_TECHNICAL_ID ? (
                                        infraWorkOnAction !== snxServiceStates.stack_for_check &&
                                        infraWorkOnAction !== snxServiceStates.stack_unknown &&
                                        infraWorkOnAction === snxServiceStates.stack_destroying &&
                                        infraWorkOnAction !== snxServiceStates.re_started ? (
                                            "Actions are momentarily unavailable"
                                        ) : (

                                            (isMetadataReloading )?
                                            (
                                                <Loading withText={false} />
                                            )
                                            :
                                            (
                                                <>
                                                    {infraWorkOnAction === "stack-for-check" ||
                                                    infraWorkOnAction === "stack-unknown" ||
                                                    infraWorkOnAction === "stack-destroyed" ||
                                                    infraWorkOnAction === "re-stopped" ? (
                                                        <>
                                                            <ButtonGeneric id="UG_stackActionPlay" onClick={ (e) => handleStartStack(e) } icon="play_arrow" iconSize="md-24" />
                                                        </>
                                                    ) : (
                                                        <>
                                                            
                                                            <ButtonGeneric id="UG_stackActionReload" onClick={ (e) => handleMetadataReload(e) } icon="sync" iconSize="md-24" />
                                                            &nbsp;&nbsp;
                                                            <ButtonGeneric id="UG_stackActionRestart" onClick={ (e) => handleRestartStack(e) } icon="restart_alt" iconSize="md-24" />
                                                            &nbsp;&nbsp;
                                                            <ButtonGeneric id="UG_stackActionStop" onClick={ (e) => handleStopProcess(e) } icon="stop" iconSize="md-24" />
                                                            &nbsp;&nbsp;
                                                            <ButtonGeneric id="UG_stackActionDestroy" onClick={ (e) => handleDestroyStack(e) } icon="delete_forever" iconSize="md-24" />
                                                        </>
                                                    )}
                                                </>
                                            )
                                        )
                                        ) : (
                                        " RestEngine API RESTful "
                                        )}
                                        </Col>
                                    </Row>
                                </Container>
                            </Card.Body>
                        </Card>
                        <Card className="snx-card mb-4 pt-3">
                            <Card.Body>
                                <Container>
                                    <Row>
                                        <Col className="d-flex justify-content-around">
                                            {isLoadingPostman ? (
                                                <Loading/>
                                            ) : (
                                                <>
                                                    {/* <Button id="UG_token" onClick= {() => _getApplicationToken( application )} className="snx-btn-action border-0"> */}
                                                    <Button id="UG_token" onClick= {() => _loginPopup()} className="snx-btn-action border-0">
                                                        <img src="../../../images/token.svg" height="25px" width="25px" loading="lazy" alt="Token" title="Token" />
                                                    </Button>
                                                    &nbsp;&nbsp;
                                                    <Link target={`${application.appInstance_name}-swagger`} to={`/accounts/${account.name}/applications/${application.id}/swagger`}>
                                                        <Button id="UG_swagger" className="snx-btn-action border-0">
                                                            <img src="../../../images/swagger.svg" height="25px" width="25px" loading="lazy" alt="Swagger" title="Swagger" />
                                                        </Button>
                                                    </Link>
                                                    &nbsp;&nbsp;
                                                    <Button id="UG_postman" onClick={(e) => _getPostmanExportFile() } className="snx-btn-action border-0">
                                                        <img src="../../../images/postman.svg" height="25px" width="25px" loading="lazy" alt="Postman" title="Postman" />
                                                    </Button>
                                                </>
                                            )}
                                            
                                        </Col>
                                    </Row>
                                </Container>
                            </Card.Body>
                        </Card>
                        <br/>
                    </Col>
                    <Col lg="8">
                            <Card className="snx-card">
                                <Card.Header className="border-bottom">
                                    
                                    <h6 className="m-0" style={{ float: "left"}}>{context.t('Details')}</h6>
                                    
                                    {/* <div className="mb-0 mx-auto"> */}
                                    {/* </div> */}
                                    <ButtonBack onClick={e => { history.goBack() }} />
                                </Card.Header>
                                <Card.Body className="pt-0">
                                    <br />
                                        <Row>
                                            <Col lg="6">
                                                <InputField label= { context.t('Api Key') }
                                                    name="apikey"
                                                    disabled={true}
                                                    useFormRegister= { register("apikey") }
                                                />
                                            </Col>
                                            <Col lg="6">
                                                <InputField label= { context.t('Audience') }
                                                    name="audience"
                                                    disabled={true}
                                                    useFormRegister= { register("audience") }
                                                />
                                            </Col>
                                            {bussinesDB ? (
                                                <Col lg="6">
                                                    <InputField label= { context.t('Database Name') }
                                                        name="databaseName"
                                                        disabled={true}
                                                        useFormRegister= { register("databaseName") }
                                                    />
                                                    <InputField label= { context.t('Database Host') }
                                                        name="databaseHost"
                                                        disabled={true}
                                                        useFormRegister= { register("databaseHost") }
                                                    />
                                                </Col>
                                            ) : (
                                                ""
                                            )}
                                            {sxreStack ? (
                                                <>
                                                    <Col lg="6">
                                                    <InputField label= { context.t('Stack Name') }
                                                            name="stackName"
                                                            disabled={true}
                                                            useFormRegister= { register("stackName") }
                                                        />
                                                        <InputField label= { context.t('Id Swarm') }
                                                            name="idSwarm"
                                                            disabled={true}
                                                            useFormRegister= { register("idSwarm") }
                                                        />
                                                    </Col>
                                                </>
                                            ) : (
                                            ""
                                            )}
                                        </Row>
                                        <Row>
                                            <Col lg="6">
                                                <ButtonHelp page={"Application"} context={context} />
                                            </Col>
                                            <Col lg="6">
                                                {user.roles[0].id === types.USER_ROOT_ID || user.roles[0].id === types.USER_ADMIN_ID || user.roles[0].id === types.USER_TECHNICAL_ID ? (
                                                        
                                                        <Link to={"/accounts/" + application.account_id + "/apps/edit/" + application.id}>
                                                            <Button className="snx-btn-action border-0 float-right">
                                                                <i className="material-icons fon" style={{ fontSize: "18px" }}>edit</i>
                                                            </Button>
                                                        </Link>
                                                ) : (
                                                ""
                                                )}
                                            </Col>
                                        </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {infraWorkOnAction ? (
                        <Row>
                            <Container fluid>
                            <br />
                            <div>
                                {/* <h5> */}
                                { renderMainInfraLoading(infraWorkOnAction) }
                                {/* </h5> */}
                            </div>
                            </Container>
                        </Row>
                    ) : (
                    // TODO ELIMINAR O CAMBIAR TEXTO
                        <>
                            <i className="fas fa-cog fa-spin"></i>
                            {console.log("this.state: " + this.state) +
                            context.t("Checking services...")}
                        </>
                    )}
                </Container>
                <br />
                <br />
            </>
        );
    }
};

Application.contextTypes = {
    t: PropTypes.func.isRequired
}

export default Application;